import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "6.5 6.5 39 39",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19.86 25.84a1.5 1.5 0 0 0-2.12 2.12l2.12-2.12Zm4.34 6.46-1.06 1.06a1.5 1.5 0 0 0 2.212-.1L24.2 32.3Zm10.152-9.84a1.5 1.5 0 1 0-2.304-1.92l2.304 1.92Zm-16.613 5.5 5.4 5.4 2.122-2.12-5.4-5.4-2.122 2.12Zm7.613 5.3 9-10.8-2.304-1.92-9 10.8 2.304 1.92ZM42.5 26c0 9.113-7.387 16.5-16.5 16.5v3c10.77 0 19.5-8.73 19.5-19.5h-3ZM26 42.5c-9.113 0-16.5-7.387-16.5-16.5h-3c0 10.77 8.73 19.5 19.5 19.5v-3ZM9.5 26c0-9.113 7.387-16.5 16.5-16.5v-3C15.23 6.5 6.5 15.23 6.5 26h3ZM26 9.5c9.113 0 16.5 7.387 16.5 16.5h3c0-10.77-8.73-19.5-19.5-19.5v3Z" }, null, -1)
  ]))]))
}
export default { render: render }